import React from "react";
import { useRef } from "react";
import suggestion1Image from "../../../images/image1.jpg";
import suggestion2Image from "../../../images/image2.jpg";
import suggestion3Image from "../../../images/image3.jpg";
import suggestion4Image from "../../../images/image4.jpg";
import "./Suggestion.css";

function Suggestion({ isActiveSuggestion, scrollItem, onScrollItem }) {
  const companyName = `ООО "РЭК"`;

  const attentionText1 = ` получило право поставки электроэнергии промышленным потребителям с ОРЭМ с 01.08.2025 года.
   Для регистрации точек поставки электроэнергии потребителя на ОРЭМ потребитель должен обладать присоединенной мощностью силовых трансформаторов не менее 750 кВА.
   `;

  const attentionText2FirstHalf = `Объем ежемесячного потребления электроэнергии для сотрудничества с ООО "РЭК" должен превышать 300 000 кВт*ч. `;

  const suggestionRef = useRef();


  React.useEffect(()=>{
    if (scrollItem === "suggestion") {
      onScrollItem(suggestionRef);
    }
  },[onScrollItem,scrollItem])

  return (
    <section ref={suggestionRef} className="suggestion page__container">
      <div className="suggestion__container">
        <h2 className="suggestion__title">Что мы предлагаем</h2>
      </div>

      <ul className="suggestion__cards">
        <li className="suggestion__card">
          <div className="suggestion__image-container">
            <img
              className="suggestion__image"
              src={suggestion1Image}
              alt="Изображение предложения"
            ></img>
          </div>
          <p className="suggestion__description">
            Поставка электроэнергии с оптового рынка электроэнергии (мощности) (ОРЭМ) с 2025 года
          </p>
        </li>
        <li className="suggestion__card">
          <div className="suggestion__image-container">
            <img
              className="suggestion__image"
              src={suggestion2Image}
              alt="Изображение предложения"
            ></img>
          </div>
          <p className="suggestion__description">
            Снижение затрат на электроэнергию за счет скидки от действующих цен ГП
          </p>
        </li>
        <li className="suggestion__card">
          <div className="suggestion__image-container">
            <img
              className="suggestion__image"
              src={suggestion4Image}
              alt="Изображение предложения"
            ></img>
          </div>
          <p className="suggestion__description">
            Контроль электроэнергии через автоматизированную систему (АИИС КУЭ)
          </p>
        </li>
        <li className="suggestion__card">
          <div className="suggestion__image-container">
            <img
              className="suggestion__image"
              src={suggestion3Image}
              alt="Изображение предложения"
            ></img>
          </div>
          <p className="suggestion__description">
            Построение систем коммерческого учета электроэнергии в соответствии с требованиям ОРЭМ (АИИС КУЭ)
          </p>
        </li>
      </ul>

      <article className={`suggestion__attention-container inactive ${isActiveSuggestion ? "active" : ""}`}>
        <h3 className="suggestion__attention-title">
          Обращаем внимание клиента
        </h3>
        <div className="suggestion__attention-text-container">
          <span className="suggestion__attention-text suggestion__attention-text_size_l">
            {companyName}
          </span>
          <p className="suggestion__attention-text">{attentionText1}</p>
        </div>
        <div className="suggestion__attention-text-container">
          <p className="suggestion__attention-text">
            {attentionText2FirstHalf}
          </p>
        </div>
      </article>
    </section>
  );
}

export default Suggestion;
